module.exports = __webpack_public_path__ + "static/media/landing.5ca3aaf4.png";